module.exports = __webpack_public_path__ + "img/bg-icon2.b3e040c9.png";